import { TASKS_SERVICE } from "@/services/tasks.service.js";
import router from '@/router/index';

const state = { listOutput: {}, taskOutput: {}, updateStatusTask: false};

const actions = {
    getList({ dispatch, commit }, inputGetTasks) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');
        
        TASKS_SERVICE.list(inputGetTasks.pageNumber, inputGetTasks.resultsNumber, inputGetTasks.status, inputGetTasks.searchText, inputGetTasks.orderBy)
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    editTask({ dispatch, commit }, inputTask) {
        dispatch('alert/clear', null, { root: true });
        commit('editRequest');
        TASKS_SERVICE.edit(inputTask.id, inputTask.task)
            .then(
                output => {
                    commit('editSuccess', output);
                },
                error => {
                    commit('editFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    addTask({ dispatch, commit }, inputTask) {
        dispatch('alert/clear', null, { root: true });
        commit('addRequest');

        TASKS_SERVICE.add(inputTask.task)
            .then(
                output => {
                    commit('addSuccess', output);
                },
                error => {
                    commit('addFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    getTask({ dispatch, commit }, taskId) {
        dispatch('alert/clear', null, { root: true });
        commit('getRequest');

        TASKS_SERVICE.get(taskId)
            .then(
                output => {
                    commit('getSuccess', output);
                },
                error => {
                    commit('getFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    updateStatus({ dispatch, commit }, inputStatus) {
        dispatch('alert/clear', null, { root: true });
        commit('updateStatusRequest');

        TASKS_SERVICE.updateStatus(inputStatus.id, inputStatus.status)
            .then(
                output => {
                    commit('updateStatusSuccess', output);
                },
                error => {
                    commit('updateStatusFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        //
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = {};
    },
    /* Add */
    addRequest(state) {
    },
    addSuccess(state) {
        router.push('/tarefas/lista');
    },
    addFailure(state) {
        //
    },
    /* Edit */
    editRequest(state) {
    },
    editSuccess(state) {
        router.push('/tarefas/lista');
    },
    editFailure(state) {
        //
    },
    /* Get */
    getRequest(state) {
        //
    },
    getSuccess(state, output) {
        state.taskOutput = output;
    },
    getFailure(state) {
        state.taskOutput = {};
    },
    /* Update status */
    updateStatusRequest(state) {
        state.updateStatusTask = undefined;
    },
    updateStatusSuccess(state) {
        state.updateStatusTask = true;
    },
    updateStatusFailure(state) {
        state.updateStatusTask = false;
    },
};

export const tasks = {
    namespaced: true,
    state,
    actions,
    mutations
};